import { useMemo, useState } from 'react'

import { VARIATION_TYPES } from 'Pods/ThreeDStudio/constants'

const getCategory = variation => VARIATION_TYPES[variation.providerModelId]?.tab

// A null category means "All".
function useCategoryFilters(variations) {
  const [pickedCategory, setPickedCategory] = useState(null)

  const countByCategory = useMemo(() => variations.reduce((counts, variation) => {
    const category = getCategory(variation)
    return category ? { ...counts, [category]: (counts[category] ?? 0) + 1 } : counts
  }, {}), [variations])

  // Empty categories are disabled, so one that loses its last variation (e.g. it was
  // deleted) falls back to All instead of leaving an empty, unclickable filter selected.
  const selectedCategory = countByCategory[pickedCategory] ? pickedCategory : null

  const filteredVariations = useMemo(() => (
    selectedCategory == null
      ? variations
      : variations.filter(variation => getCategory(variation) === selectedCategory)
  ), [variations, selectedCategory])

  return {
    selectedCategory,
    countByCategory,
    filteredVariations,
    selectCategory: setPickedCategory,
  }
}

export default useCategoryFilters
